
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions-and-events/event",
      function () {
        return require("private-next-pages/exhibitions-and-events/event/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions-and-events/event"])
      });
    }
  